import { Grid, Toaster } from '@grupoboticario/flora-react'

import FormField from '@/components/FormField/FormField'
import { SearchIcon } from '@/icons/SearchIcon'
import { getPostalCodeApi, getRegionClientId, getRegionClientSecret } from '@/utils/envUtils'

import * as S from './Shipping.styles'

const Shipping = ({ address, errors, setAddress, isDisabled = false }) => {
  const onPostalCodeChange = async (postalCode) => {
    if (postalCode.length === 8) {
      try {
        const response = await fetch(`${getPostalCodeApi()}?postalCode=${postalCode}`, {
          headers: {
            client_id: getRegionClientId(),
            client_secret: getRegionClientSecret()
          }
        })

        if (!response.ok) throw new Error(`HTTP error ${response.status}`)

        const data = await response.json()
        setAddress(data)
      } catch {
        setAddress({
          postalCode,
          streetAddress: '',
          addressNumber: '',
          district: '',
          complement: '',
          addressLocality: '',
          addressRegion: '',
          country: ''
        })

        Toaster.notify({
          kind: 'error',
          description: 'CEP inválido, por favor tente novamente!'
        })
      }
    } else {
      setAddress({
        streetAddress: '',
        addressNumber: '',
        district: '',
        complement: '',
        addressLocality: '',
        addressRegion: '',
        country: ''
      })
    }
  }

  return (
    <Grid align="start" css={S.shippingGridCss} gap="$4">
      <FormField
        data-testid="postalCode"
        disabled={isDisabled}
        invalid={typeof errors?.postalCode === 'string'}
        invalidText={errors?.postalCode}
        labelText="CEP: "
        maxLength="8"
        name="postalCode"
        onValueChange={onPostalCodeChange}
        rightIcon={<SearchIcon />}
      />
      <FormField
        data-testid="addressInput"
        disabled={!!address?.streetAddress || isDisabled}
        labelText="Logradouro: "
        name="streetAddress"
      />
      <FormField disabled={isDisabled} labelText="Número: " name="addressNumber" />
      <FormField disabled={!!address?.district || isDisabled} labelText="Bairro: " name="district" />
      <FormField disabled={isDisabled} labelText="Complemento: " name="complement" />
      <FormField disabled={!!address?.addressLocality || isDisabled} labelText="Cidade: " name="addressLocality" />
      <FormField disabled={!!address?.addressRegion || isDisabled} labelText="UF: " name="addressRegion" />
      <FormField disabled={!!address?.country || isDisabled} labelText="País: " name="country" value="Brasil" />
    </Grid>
  )
}

export default Shipping
